import canvaIcon from './canva-icon.png';

export const CanvaLogo = ({ className, size = 20 }: { className?: string; size?: number }) => (
  <img src={canvaIcon} alt="Canva" className={className} width={size} height={size} />
);
